<template>
    <div class="ability">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/ability-titile-icon.png" alt="">能力进阶</div>
                <ul class="course-detail">
                    <li>针对6岁半-9岁半的孩子，锻炼他们的思维力和自主学习能力，</li>
                    <li>帮助他们树立正确的人生观，培养积极的生活态度。</li>
                </ul>
            </div>
        </div>
        <div class="course-content">
            <div class="course-content max-title" style="margin-bottom:0;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">名人传故事</button>
                </div>
            </div>

            <ul class="list-text">
                <li>通过阅读名人传记,探讨名人成功故事,激发孩子的志气,帮助他们培养健康的人格,增强</li>
                <li>克服困难与挫折的勇气,增长应事接物的智慧。</li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;justify-content: center">
                    <img src="../../assets/imgs/course/ability-1.png" alt="">
                    <img src="../../assets/imgs/course/ability-2.png" alt="">
                    <img src="../../assets/imgs/course/ability-3.png" alt="">
                </li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">金言诵读</button>
                </div>
            </div>
            <ul class="list-text">
                <li style="display: flex;justify-content: center;align-items: center">
                    <div style="margin-right:40px">通过反复诵读正能量的名人名言,帮助孩子树立正确的人生观,让孩子待 人接物时能有乐观的心态。</div>
                    <img style="margin-right:40px" src="../../assets/imgs/course/ability-4.png" alt="">
                    <img src="../../assets/imgs/course/ability-5.png" alt="">
                </li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;justify-content: space-between;">
                     <div style="flex: 1;margin-right: 40px">
                        <div class="content-item">
                            <div class="content-title">
                                <button class="page-btn">地图作文</button>
                            </div>
                        </div>
                         <ul class="list-text">
                             <li>以一个主题不断进行连锁的扩散,发散性</li>
                             <li>的完成一篇作文。</li>
                         </ul>
                         <div style="margin-top:100px"><img src="../../assets/imgs/course/ability-6.png" alt=""></div>
                     </div>
                    <div style="flex: 1">
                        <div class="content-item">
                            <div class="content-title">
                                <button class="page-btn">辩论</button>
                            </div>
                        </div>
                        <ul class="list-text">
                            <li>一次一个主题,让孩子先建立观点,在大脑中分析论点,</li>
                            <li>然后进行正反方分组,组织两方进行辩论,锻炼孩子的即</li>
                            <li>兴语言组织能力及表达能力。</li>
                        </ul>
                        <div><img src="../../assets/imgs/course/ability-7.png" alt=""></div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ability",
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
    .ability{
        .course-header{
            background-image: url("../../assets/imgs/course/ability-bg.png");
        }
        .max-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #A3CF6C;
            margin-bottom: 15px;
            margin-top: 50px;
            padding-bottom: 10px;
            border-bottom: 1px solid #A3CF6C;
            span:first-child{
                font-weight: 600;
                font-size: 35px;
            }
            span:last-child{
                font-size: 20px;
            }
        }
        .content-item{
            margin-bottom: 20px;
            border-top: 1px solid #A3CF6C;
            .page-btn{
                width: 150px;
                height: 40px;
                font-weight: 600;
                font-size: 20px;
                background: #A3CF6C;
                color: #fff;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                border: none;
                outline: none;
            }
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>